import { object, ObjectSchema, string } from 'yup';

import { CountryValue } from '@client/api';

const schema: ObjectSchema<CountryValue> = object({
  threeLetterCode: string().required(),
  twoLetterCode: string().nullable(),
  name: string().nullable()
});

export { schema as countryValueSchema };
